import React from 'react';
import SiFace from './SiFace';
/**
 * The SIs already in the meeting or on their way, as a row of faces.
 *
 * @returns {ReactElement}
 */
export default function PresentStrip({ present, w }) {
    return (React.createElement("section", { className: 'ksi-present' },
        React.createElement("h3", { className: 'ksi-group-title' }, w('siInvite.groupPresent')),
        React.createElement("ul", { className: 'ksi-present-list' }, present.map(p => (React.createElement("li", { className: 'ksi-present-item', key: p.memberId },
            React.createElement("div", { className: `ksi-face ksi-face-sm${p.state === 'JOINING' ? ' ksi-face-busy' : ''}` },
                React.createElement(SiFace, { name: p.name, size: 28, url: p.avatarUrl })),
            React.createElement("span", { className: 'ksi-present-name' }, p.name),
            React.createElement("span", { className: `ksi-present-state ksi-tone-text-${p.state === 'IN_MEETING' ? 'ok' : 'busy'}` }, p.state === 'IN_MEETING' ? w('siInvite.inMeeting') : w('siInvite.joining'))))))));
}
